const initialFilters = JSON.parse(localStorage.getItem('globalFilters')) || {};

const state = {
    country: initialFilters.country || '',
    account: initialFilters.account || 0,
};

export default state;
